import React from 'react';
import { Link } from 'react-router-dom';
import withFacet from '../../../../../../Hooks/Shared/Facet/withFacet';

class FacetNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.excludeFacets = false;
    this.state.storedFacet = this.props.passedAppFunctions.getURLParamValue('facet');
    this.state.storedOrderBy = this.props.passedAppFunctions.getURLParamValue('orderBy');
  }

  shouldComponentUpdate(nextProps, nextState) {
    var returnValue = false;
    if (nextProps.passedAppFunctions.quickviewIsOpen) {
      return false;
    }
    if (
      !_.isEqual(
        nextProps.passedAppFunctions.routeInfo.location.pathname,
        this.props.passedAppFunctions.routeInfo.location.pathname
      )
    ) {
      return true;
    }

    if (!_.isEqual(nextProps.passedAppFunctions.navigationToggles, this.props.passedAppFunctions.navigationToggles)) {
      returnValue = true;
    }
    if (
      !_.isEqual(nextProps.passedAppFunctions.seoColorInfo, this.props.passedAppFunctions.seoColorInfo) ||
      this.props.passedAppFunctions.getURLParamValue('facet') != this.state.storedFacet
    ) {
      this.state.storedFacet = this.props.passedAppFunctions.getURLParamValue('facet');
      returnValue = true;
    }
    if (this.props.passedAppFunctions.getURLParamValue('orderBy') != this.state.storedOrderBy) {
      this.state.storedOrderBy = this.props.passedAppFunctions.getURLParamValue('orderBy');
      returnValue = true;
    }
    if (this.props.excludeFacets === true || !_.isEqual(nextProps.excludeFacets, nextState.excludeFacets)) {
      returnValue = true;
    }
    return returnValue || !_.isEqual(this.props.facetsJSON, nextProps.facetsJSON);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.passedAppFunctions.windowPosition != this.props.passedAppFunctions.windowPosition) {
      this.props.passedAppFunctions.setNavigationToggle('keepPos', true);
      window.scrollTo(0, this.props.passedAppFunctions.windowPosition);
    }
  }
  componentWillUnmount() {
    if (this.props.widgetData.orientation == 'vertical') {
      this.props.passedAppFunctions.setNavigationToggle('keepPos', false);
      this.props.passedAppFunctions.setWindowPosition('windowPosition', 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      document.body.classList.remove('filter-open');
    }
  }
  render() {
    const verticalFacets = [];
    var horizontalFacets = [];
    var containsValues = false;

    // creating a new pipedSizes object in facetsJSON if "attribute name | size" exists
    if (this.props.widgetData.widgetType === 'FacetNavigation') {
      const copiedFacetsJson = this.props.facetsJSON ? JSON.parse(JSON.stringify(this.props.facetsJSON)) : '';
      if (typeof copiedFacetsJson !== 'undefined' && Object.keys(copiedFacetsJson).length !== 0) {
        const tempObject = {};
        Object.entries(copiedFacetsJson).forEach((facet) => {
          const [facetKey, facetValue] = facet;
          if (facetValue.facetTitle && facetValue.facetTitle.indexOf('|') > -1) {
            let facetName = facetKey;
            let facetTitle = facetValue.facetTitle.split('|')[0].trim();
            let values = facetValue.values;
            if (values.length > 0) {
              let temp = { [facetName]: { facetTitle: facetTitle, values: values } };
              Object.assign(tempObject, temp);
            }
          }
        });
        // If more than one piped facet - roll them up. Else, we'll just treat it like a regular facet
        if (Object.keys(tempObject).length > 1) {
          this.props.facetsJSON.pipedSizes = {};
          Object.assign(this.props.facetsJSON.pipedSizes, tempObject);
        }
      }
    }

    // if the new pipedSizes object is in this.props.facetsJSON, add "pipedSizes" to the verticalFacets array
    // and remove the "attribute name | size" facets from the facets list
    if (this.props.facetsJSON.facetsList) {
      if ('pipedSizes' in this.props.facetsJSON) {
        verticalFacets.push('pipedSizes');
      }
      for (let i = 0; i < this.props.facetsJSON.facetsList.length; i++) {
        let thisFacet = this.props.facetsJSON.facetsList[i];
        if (this.props.facetsJSON[thisFacet].values.length > 0) {
          containsValues = true;
        } else {
          containsValues = false;
        }
        if (thisFacet !== 'mfName_ntk_cs' && containsValues) {
          // if no pipedSizes, add thisFacet to the facet list. Else...
          if (this.props.facetsJSON.pipedSizes === undefined) {
            verticalFacets.push(thisFacet);
          } else {
            // pipedSizes exists. it's already in the facet list and the piped facets are in the facetsJSON object -- done with piped stuff here.
            // so, if thisFacet doesn't have a piped title in facetsJSON -- add it to the list
            if (this.props.facetsJSON[thisFacet].facetTitle.indexOf('|') === -1) {
              verticalFacets.push(thisFacet);
            }
          }
        }
      }
    }

    return (
      <div data-widgetname='FacetNavigation'>
        {this.props.widgetData.orientation == 'vertical' || this.props.facetsInCatNav ? (
          this.props.facetsInCatNav && this.props.passedAppFunctions.siteFormat == 'desktop' ? (
            <VerticalFacetNavigation
              facetsInCatNav={this.props.facetsInCatNav}
              slotNumber={this.props.slotNumber}
              facetUsageTracking={this.props.facetUsageTracking}
              isFacetSelected={this.props.isFacetSelected}
              passedAppFunctions={this.props.passedAppFunctions}
              facetsList={verticalFacets}
              facetsJSON={this.props.facetsJSON}
              widgetData={this.props.widgetData}
              generateLinkForFacet={this.props.generateLinkForFacet}
              excludeFacets={this.props.excludeFacets}
            />
          ) : (
            <VerticalFacetNavigation
              slotNumber={this.props.slotNumber}
              facetUsageTracking={this.props.facetUsageTracking}
              isFacetSelected={this.props.isFacetSelected}
              passedAppFunctions={this.props.passedAppFunctions}
              facetsList={verticalFacets}
              facetsJSON={this.props.facetsJSON}
              widgetData={this.props.widgetData}
              generateLinkForFacet={this.props.generateLinkForFacet}
              excludeFacets={this.props.excludeFacets}
            />
          )
        ) : (
          <HorizontalFacetNavigation
            selectedFacets={this.props.selectedFacets}
            getFacetNameFromFacetValue={this.props.getFacetNameFromFacetValue}
            facetUsageTracking={this.props.facetUsageTracking}
            isFacetSelected={this.props.isFacetSelected}
            passedAppFunctions={this.props.passedAppFunctions}
            facetsList={horizontalFacets}
            facetsJSON={this.props.facetsJSON}
            widgetData={this.props.widgetData}
            generateLinkForFacet={this.props.generateLinkForFacet}
            toggleFacetMenu={this.props.toggleFacetMenu}
            toggleSortMenu={this.props.toggleSortMenu}
            excludeFacets={this.state.excludeFacets !== undefined ? this.state.excludeFacets : ''}
          />
        )}
      </div>
    );
  }
}

class HorizontalFacetNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.excludeFacets = props.excludeFacets;
  }

  resetKeepPos = () => {
    this.props.passedAppFunctions.setNavigationToggle('keepPos', false);
  };
  render() {
    if (this.props.passedAppFunctions.siteFormat !== 'desktop') return null;
    if (this.props.selectedFacets.length === 0) return null;

    return (
      <div id='selectFilterFacets'>
        <span>
          <Link
            rel='nofollow'
            className='clearAllFilters'
            to={this.props.generateLinkForFacet(false)}
            onClick={this.resetKeepPos}
          >
            clear all
          </Link>
        </span>
        {this.props.selectedFacets.map((thisFacetValue) => {
          if (this.props.getFacetNameFromFacetValue(thisFacetValue) === 'facet') return;
          return (
            <span className='selectedFilter' key={thisFacetValue}>
              <Link rel='nofollow' to={this.props.generateLinkForFacet(thisFacetValue)} onClick={this.resetKeepPos}>
                {this.props.getFacetNameFromFacetValue(thisFacetValue).split('#double;').join('"')}
                <svg
                  role='img'
                  aria-labelledby={
                    'clearFilter' +
                    this.props
                      .getFacetNameFromFacetValue(thisFacetValue)
                      .split('#double;')
                      .join('"')
                      .split(' ')
                      .join('')
                  }
                  height='10'
                  width='10'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 48.77 48.77'
                >
                  <title
                    id={
                      'clearFilter' +
                      this.props
                        .getFacetNameFromFacetValue(thisFacetValue)
                        .split('#double;')
                        .join('"')
                        .split(' ')
                        .join('')
                    }
                  >
                    clear filter
                  </title>
                  <g data-name='Layer 2'>
                    <g data-name='Layer 1'>
                      <path d='M25.8,24.39,48.48,1.71A1,1,0,0,0,47.07.29L24.39,23,1.71.29A1,1,0,0,0,.29,1.71L23,24.39.29,47.07a1,1,0,1,0,1.41,1.41L24.39,25.8,47.07,48.48a1,1,0,0,0,1.41-1.41Z' />
                    </g>
                  </g>
                </svg>
              </Link>
            </span>
          );
        })}
      </div>
    );
  }
}

class VerticalFacetNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const facetsList = this.props.facetsList;

    if (this.props.passedAppFunctions.siteFormat == 'desktop') {
      return (
        <div className='vert-facets'>
          <div className={`filter-list`}>
            {facetsList.map((thisFacetName, index) => {
              if (
                ((thisFacetName === 'ads_f11001_ntk_cs' && this.props.facetsInCatNav === undefined) ||
                  (thisFacetName !== 'ads_f11001_ntk_cs' && this.props.facetsInCatNav === undefined)) &&
                (('FacetLocationTitle' === this.props.widgetData.widgetType &&
                  this.props.facetsJSON[thisFacetName]?.facetTitle?.toLowerCase() ===
                    this.props.widgetData.facetTitle?.toLowerCase()) ||
                  'FacetNavigation' === this.props.widgetData.widgetType)
              ) {
                return (
                  <FacetItemDesktop
                    facetUsageTracking={this.props.facetUsageTracking}
                    key={thisFacetName + index}
                    thisFacetName={thisFacetName}
                    isFacetSelected={this.props.isFacetSelected}
                    passedAppFunctions={this.props.passedAppFunctions}
                    facetsJSON={this.props.facetsJSON}
                    widgetData={this.props.widgetData}
                    generateLinkForFacet={this.props.generateLinkForFacet}
                    closeOnMount={true}
                    excludeFacets={this.props.excludeFacets !== undefined ? this.props.excludeFacets : ''}
                  />
                );
              }
            })}
          </div>
        </div>
      );
    }

    if (this.props.passedAppFunctions.siteFormat == 'tablet') {
      return (
        <div className='vert-facets'>
          <div className={`filter-list`}>
            {facetsList.map((thisFacetName, index) => {
              if (
                ('FacetLocationTitle' === this.props.widgetData.widgetType &&
                  this.props.facetsJSON[thisFacetName]?.facetTitle?.toLowerCase() ===
                    this.props.widgetData.facetTitle?.toLowerCase()) ||
                'FacetNavigation' === this.props.widgetData.widgetType
              ) {
                return (
                  <FacetItemTablet
                    facetUsageTracking={this.props.facetUsageTracking}
                    key={index}
                    thisFacetName={thisFacetName}
                    isFacetSelected={this.props.isFacetSelected}
                    passedAppFunctions={this.props.passedAppFunctions}
                    facetsJSON={this.props.facetsJSON}
                    widgetData={this.props.widgetData}
                    generateLinkForFacet={this.props.generateLinkForFacet}
                    excludeFacets={this.props.excludeFacets !== undefined ? this.props.excludeFacets : ''}
                  />
                );
              }
            })}
          </div>
        </div>
      );
    }
  }
}

class FacetItemDesktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.toggled = false;
    this.facetToggle = this.facetToggle.bind(this);
  }

  facetToggle = (event) => {
    this.props.passedAppFunctions.setNavigationToggle(event.target.id);
    const isSubFacet = event.target.id.includes('sub-facet_');
    if (!isSubFacet) {
      this.toggled = !this.toggled;
      if (this.toggled === true && event.target.id.indexOf('sub-facet_') === -1) {
        //Get difference between center and facet location
        let diff =
          document.getElementById(event.target.nextSibling.id).getBoundingClientRect().top - window.innerHeight / 2;

        setTimeout(() => {
          document.getElementById('sidebar').scrollBy({
            top: diff,
            left: 0,
            behavior: 'smooth',
          });
        }, 0);
      }
    } else {
      if (isSubFacet && event.target.classList.contains('open')) {
        let subDiff = event.target.nextElementSibling.getBoundingClientRect().top - window.innerHeight / 2;
        document.getElementById('sidebar').scrollBy({ top: subDiff, left: 0, behavior: 'smooth' });
      }
    }
  };

  thisFacetClicked = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.target.parentNode.lastChild.click();
    }
  };

  render() {
    const thisFacetName = this.props.thisFacetName;
    const pipedSizes = thisFacetName === 'pipedSizes' ? true : false;
    // if "attribute name | size" facets were in facetsJSON originally excluded from facetsList so need to check here if pipedSizes are in the list
    return (
      <React.Fragment>
        {(thisFacetName != 'mfName_ntk_cs' && !pipedSizes && this.props.facetsJSON[thisFacetName].values.length > 1) ||
        (thisFacetName != 'mfName_ntk_cs' && pipedSizes && Object.keys(this.props.facetsJSON.pipedSizes).length > 0) ? (
          <div className={`vert-facets${pipedSizes ? ' piped-vertical-facet' : ''}`} key={thisFacetName}>
            <fieldset>
              {'FacetNavigation' === this.props.widgetData.widgetType ||
              ('FacetLocationTitle' === this.props.widgetData.widgetType &&
                this.props.widgetData.facetTitle.toLowerCase() ===
                  this.props.facetsJSON[thisFacetName].facetTitle.toLowerCase() &&
                !!+this.props.widgetData.showTitle) ? (
                <>
                  <legend className='sr-only'>
                    {pipedSizes ? 'Size' : this.props.facetsJSON[thisFacetName].facetTitle}
                  </legend>
                  <button
                    id={thisFacetName}
                    className={`${
                      this.props.passedAppFunctions.navigationToggles[thisFacetName] ||
                      (this.props.passedAppFunctions.navigationToggles[thisFacetName] === undefined &&
                        this.props.facetsJSON[thisFacetName].facetTitle?.toLowerCase() === 'shop by fit')
                        ? 'open'
                        : ''
                    } facet-title facet-title-desktop${pipedSizes ? ' piped-facet-title' : ''}`}
                    onClick={this.facetToggle}
                    aria-controls={thisFacetName}
                    aria-expanded={this.props.passedAppFunctions.navigationToggles[thisFacetName] ? 'true' : 'false'}
                  >
                    {pipedSizes
                      ? 'Size'
                      : this.props.facetsJSON[this.props.thisFacetName].facetTitle.indexOf('|') > -1
                        ? this.props.facetsJSON[this.props.thisFacetName].facetTitle.split('|')[1].trim()
                        : this.props.facetsJSON[thisFacetName].facetTitle}
                  </button>
                </>
              ) : (
                <h3 className={'facet-title'}></h3>
              )}

              {pipedSizes === true ? (
                <ul className='facet desktop-vert-facet' aria-labelledby='filter_type' id={'list-' + thisFacetName}>
                  {Object.entries(this.props.facetsJSON[thisFacetName]).map((entry, i) => {
                    let facetKey = entry[0];
                    let facetTitle = entry[1].facetTitle;
                    let values = entry[1].values;
                    return (
                      <li key={facetKey}>
                        <fieldset>
                          <legend className='sr-only'>{facetTitle}</legend>
                          <button
                            id={'sub-facet_' + facetKey}
                            className={`${
                              this.props.passedAppFunctions.navigationToggles['sub-facet_' + facetKey] ? 'open' : ''
                            } facet-title facet-title-desktop sub-facet`}
                            onClick={this.facetToggle}
                            aria-controls={facetKey}
                            aria-expanded={
                              this.props.passedAppFunctions.navigationToggles['sub-facet_' + facetKey]
                                ? 'true'
                                : 'false'
                            }
                          >
                            {facetTitle}
                          </button>
                          <ul
                            className='facet desktop-vert-facet piped-facet'
                            aria-labelledby='filter_type'
                            id={facetKey}
                          >
                            {values.map((thisFacetValue) => {
                              return (
                                <li key={thisFacetValue.dsp} className='custom-control custom-checkbox'>
                                  <input
                                    className='custom-control-input'
                                    readOnly
                                    checked={this.props.isFacetSelected(thisFacetValue.val)}
                                    aria-checked={this.props.isFacetSelected(thisFacetValue.val)}
                                    type='checkbox'
                                    name={thisFacetValue.val}
                                    id={thisFacetValue.val}
                                    data-twist='size'
                                    data-facetname='size'
                                    tabIndex='0'
                                    onKeyUp={this.thisFacetClicked}
                                  />
                                  <label
                                    className='custom-control-label'
                                    htmlFor={thisFacetValue.val}
                                    onClick={(e) => e.target.nextElementSibling.click()}
                                  >
                                    <span className='sr-only'>{thisFacetValue.dsp.split('#double;').join('"')}</span>
                                  </label>
                                  <Link
                                    onClick={() => this.props.facetUsageTracking(thisFacetValue, facetTitle)}
                                    rel={
                                      this.props.isFacetSelected(thisFacetValue.val) ||
                                      this.props.generateLinkForFacet(thisFacetValue.val).indexOf('facet=') > -1
                                        ? 'nofollow'
                                        : undefined
                                    }
                                    to={this.props.generateLinkForFacet(thisFacetValue.val)}
                                    tabIndex='-1'
                                  >
                                    {thisFacetValue.dsp.split('#double;').join('"')}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </fieldset>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <ul className='facet desktop-vert-facet' aria-labelledby='filter_type' id={thisFacetName}>
                  {this.props.facetsJSON[thisFacetName].values.map((thisFacetValue, index) =>
                    thisFacetValue.dsp.length <= 0 ||
                    thisFacetValue.dsp.split('#double;').join('"').indexOf('Multi/Misc') >= 0 ? null : (
                      <li
                        key={thisFacetValue.dsp}
                        className={`custom-control custom-checkbox ${this.props.facetsJSON[thisFacetName].facetTitle == 'color' ? 'color-label' : ''}`}
                      >
                        {this.props.facetsJSON[thisFacetName].facetTitle == 'color' ? (
                          <span
                            className='navColorFacet'
                            id={thisFacetValue.dsp.split('/').join('')}
                            aria-labelledby={thisFacetValue.dsp}
                            alt={thisFacetValue.dsp.split('/').join('')}
                            onClick={(e) => e.target.parentNode.lastChild.click()}
                          ></span>
                        ) : (
                          ''
                        )}
                        <input
                          className='custom-control-input'
                          readOnly
                          checked={this.props.isFacetSelected(thisFacetValue.val)}
                          aria-checked={this.props.isFacetSelected(thisFacetValue.val)}
                          type='checkbox'
                          name={thisFacetValue.val}
                          id={thisFacetValue.val}
                          data-twist={this.props.facetsJSON[thisFacetName].facetTitle}
                          data-facetname={this.props.facetsJSON[thisFacetName].facetTitle}
                          tabIndex='0'
                          onKeyUp={this.thisFacetClicked}
                        />
                        <label
                          className='custom-control-label'
                          htmlFor={thisFacetValue.val}
                          onClick={(e) => e.target.nextElementSibling.click()}
                        >
                          <span className='sr-only'>{thisFacetValue.dsp.split('#double;').join('"')}</span>
                        </label>
                        <Link
                          onClick={() =>
                            this.props.facetUsageTracking(
                              thisFacetValue,
                              this.props.facetsJSON[thisFacetName].facetTitle
                            )
                          }
                          rel={
                            this.props.isFacetSelected(thisFacetValue.val) ||
                            this.props.generateLinkForFacet(thisFacetValue.val).indexOf('facet=') > -1
                              ? 'nofollow'
                              : undefined
                          }
                          to={this.props.generateLinkForFacet(thisFacetValue.val)}
                          tabIndex='-1'
                        >
                          {thisFacetValue.dsp.split('#double;').join('"')}
                        </Link>
                      </li>
                    )
                  )}
                </ul>
              )}
            </fieldset>
          </div>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }
}

class FacetItemTablet extends React.Component {
  constructor(props) {
    super(props);
    this.facetToggle = this.facetToggle.bind(this);
  }

  facetToggle(event) {
    this.props.passedAppFunctions.setNavigationToggle(event.target.id);
  }

  render() {
    const thisFacetName = this.props.thisFacetName;
    const pipedSizes = thisFacetName === 'pipedSizes' ? true : false;

    return (
      <React.Fragment>
        {(thisFacetName != 'mfName_ntk_cs' && !pipedSizes && this.props.facetsJSON[thisFacetName].values.length > 1) ||
        (thisFacetName != 'mfName_ntk_cs' && pipedSizes && Object.keys(this.props.facetsJSON.pipedSizes).length > 0) ? (
          <div
            className={`vert-facets${pipedSizes ? ' piped-vertical-facet' : ''}`}
            key={thisFacetName}
            role='button'
            aria-haspopup='menu'
          >
            {'FacetNavigation' === this.props.widgetData.widgetType ||
            ('FacetLocationTitle' === this.props.widgetData.widgetType &&
              this.props.widgetData.facetTitle.toLowerCase() ===
                this.props.facetsJSON[thisFacetName].facetTitle.toLowerCase() &&
              !!+this.props.widgetData.showTitle) ? (
              <button
                id={thisFacetName}
                className={`${
                  this.props.passedAppFunctions.navigationToggles[thisFacetName] ||
                  (this.props.passedAppFunctions.navigationToggles[thisFacetName] === undefined &&
                    this.props.facetsJSON[thisFacetName].facetTitle?.toLowerCase() === 'shop by fit')
                    ? 'open'
                    : ''
                } facet-title${pipedSizes ? ' piped-facet-title' : ''}`}
                onClick={this.facetToggle}
                aria-controls={thisFacetName}
                aria-expanded={this.props.passedAppFunctions.navigationToggles[thisFacetName] ? 'true' : 'false'}
              >
                {pipedSizes
                  ? 'Size'
                  : this.props.facetsJSON[this.props.thisFacetName].facetTitle.indexOf('|') > -1
                    ? this.props.facetsJSON[this.props.thisFacetName].facetTitle.split('|')[1].trim()
                    : this.props.facetsJSON[thisFacetName].facetTitle}
              </button>
            ) : (
              <button className={'open facet-title noTitle'}></button>
            )}

            {'FacetNavigation' === this.props.widgetData.widgetType ||
            ('FacetLocationTitle' === this.props.widgetData.widgetType &&
              this.props.widgetData.facetTitle.toLowerCase() ===
                this.props.facetsJSON[thisFacetName].facetTitle.toLowerCase()) ? (
              <fieldset>
                <legend className='sr-only'>{this.props.facetsJSON[thisFacetName].facetTitle}</legend>
                <ul className='facet' role='menu' id={'list-' + thisFacetName}>
                  {pipedSizes === true
                    ? Object.entries(this.props.facetsJSON[thisFacetName]).map((entry) => {
                        let facetKey = entry[0];
                        let facetTitle = entry[1].facetTitle;
                        let values = entry[1].values;
                        return (
                          <li key={facetKey}>
                            <fieldset>
                              <legend className='sr-only'>{facetTitle}</legend>
                              <button
                                id={'sub-facet_' + facetKey}
                                className={`${this.props.passedAppFunctions.navigationToggles['sub-facet_' + facetKey] ? 'open ' : ''}sub-facet facet-title`}
                                onClick={this.facetToggle}
                                aria-controls={facetKey}
                                aria-expanded={
                                  this.props.passedAppFunctions.navigationToggles['sub-facet_' + facetKey]
                                    ? 'true'
                                    : 'false'
                                }
                              >
                                {facetTitle}
                              </button>
                              <ul className='facet piped-facet' role='menu' id={facetKey}>
                                {values.map((thisFacetValue) => {
                                  return (
                                    <li key={thisFacetValue.dsp} className='custom-control custom-checkbox'>
                                      <input
                                        className='custom-control-input'
                                        readOnly
                                        checked={this.props.isFacetSelected(thisFacetValue.val)}
                                        type='checkbox'
                                        name={thisFacetValue.val}
                                        id={thisFacetValue.val}
                                        data-twist={this.props.facetsJSON[thisFacetName].facetTitle}
                                        data-facetname={this.props.facetsJSON[thisFacetName].facetTitle}
                                        tabIndex='0'
                                      />
                                      <label
                                        className='custom-control-label'
                                        htmlFor={thisFacetValue.val}
                                        onClick={(e) => e.target.nextElementSibling.click()}
                                      >
                                        <span className='sr-only'>
                                          {thisFacetValue.dsp.split('#double;').join('"')}
                                        </span>
                                      </label>
                                      <Link
                                        onClick={() => this.props.facetUsageTracking(thisFacetValue, facetTitle)}
                                        rel={
                                          this.props.isFacetSelected(thisFacetValue.val) ||
                                          this.props.generateLinkForFacet(thisFacetValue.val).indexOf('facet=') > -1
                                            ? 'nofollow'
                                            : undefined
                                        }
                                        to={this.props.generateLinkForFacet(thisFacetValue.val.split('%C2%AE'))}
                                        tabIndex='-1'
                                      >
                                        {thisFacetValue.dsp.split('#double;').join('"')}
                                      </Link>
                                    </li>
                                  );
                                })}
                              </ul>
                            </fieldset>
                          </li>
                        );
                      })
                    : this.props.facetsJSON[thisFacetName].values.map((thisFacetValue, index) =>
                        thisFacetValue.dsp.length <= 0 ||
                        thisFacetValue.dsp.split('#double;').join('"').indexOf('Multi/Misc') >= 0 ? null : (
                          <li
                            key={thisFacetValue.dsp}
                            className={`custom-control custom-checkbox ${this.props.facetsJSON[thisFacetName].facetTitle == 'color' ? 'color-label' : ''}`}
                          >
                            {this.props.facetsJSON[thisFacetName].facetTitle == 'color' ? (
                              <span
                                className='navColorFacet'
                                id={thisFacetValue.dsp.split('/').join('')}
                                aria-labelledby={thisFacetValue.dsp}
                                alt={thisFacetValue.dsp.split('/').join('')}
                                onClick={(e) => e.target.parentNode.lastChild.click()}
                              ></span>
                            ) : (
                              ''
                            )}
                            <input
                              className='custom-control-input'
                              readOnly
                              checked={this.props.isFacetSelected(thisFacetValue.val)}
                              type='checkbox'
                              name={thisFacetValue.val}
                              id={thisFacetValue.val}
                              data-twist={this.props.facetsJSON[thisFacetName].facetTitle}
                              data-facetname={this.props.facetsJSON[thisFacetName].facetTitle}
                              tabIndex='0'
                            />
                            <label
                              className={
                                this.props.facetsJSON[thisFacetName].facetTitle == 'color'
                                  ? 'custom-control-label'
                                  : 'custom-control-label-nocolor custom-control-label'
                              }
                              htmlFor={thisFacetValue.val}
                              onClick={(e) => e.target.nextElementSibling.click()}
                            >
                              <span className='sr-only'>{thisFacetValue.dsp.split('#double;').join('"')}</span>
                            </label>
                            <Link
                              onClick={() =>
                                this.props.facetUsageTracking(
                                  thisFacetValue,
                                  this.props.facetsJSON[thisFacetName].facetTitle
                                )
                              }
                              rel={
                                this.props.isFacetSelected(thisFacetValue.val) ||
                                this.props.generateLinkForFacet(thisFacetValue.val).indexOf('facet=') > -1
                                  ? 'nofollow'
                                  : undefined
                              }
                              to={this.props.generateLinkForFacet(thisFacetValue.val)}
                              tabIndex='-1'
                            >
                              {thisFacetValue.dsp.split('#double;').join('"')}
                            </Link>
                          </li>
                        )
                      )}
                </ul>
              </fieldset>
            ) : (
              ''
            )}
          </div>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }
}

export default withFacet(FacetNavigation);
